import * as React from "react"

export default function HelmetIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={61}
      height={61}
      viewBox="0 0 61 61"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_1283_45142)" fill={props.fill}>
        <path d="M55.538 35.88c-.033-.265-.07-.529-.11-.791-.811-5.234-2.332-10.258-4.62-14.563-2.77.264-5.723.636-8.453 1.164-2.449.473-4.618 1.054-6.28 1.748-1.763.737-2.504 1.418-2.721 1.81-.578 1.04-.486 2.65.548 4.405 1.045 1.774 2.584 2.867 3.645 3.054l17.991 3.172z" />
        <path d="M55.6 40.971l-18.922-3.336c-2.97-.524-5.58-2.884-7.087-5.442-1.519-2.578-2.384-6.181-.612-9.374 1.07-1.928 3.16-3.159 5.168-3.998 2.11-.88 4.653-1.54 7.259-2.044 2.066-.4 4.234-.713 6.35-.96-3.357-4.242-7.773-7.25-13.335-8.23-12.246-2.16-23.923 6.017-26.083 18.263-1.225 6.95.879 13.717 5.166 18.665l29.842 5.262c8.249 1.455 11.606-3.115 12.255-8.806z" />
      </g>
      <defs>
        <clipPath id="clip0_1283_45142">
          <path fill="#fff" transform="translate(.5 .145)" d="M0 0H60V60H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
